import { render, staticRenderFns } from "./MakingAppointmentMasseuseAll.vue?vue&type=template&id=3bf6743c&scoped=true&"
import script from "./MakingAppointmentMasseuseAll.vue?vue&type=script&lang=js&"
export * from "./MakingAppointmentMasseuseAll.vue?vue&type=script&lang=js&"
import style0 from "./MakingAppointmentMasseuseAll.vue?vue&type=style&index=0&id=3bf6743c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf6743c",
  null
  
)

export default component.exports